module.exports = __webpack_public_path__ + "static/media/20220716-dan-juergen-schwitzkasten.fb49c303.jpg";